export default __webpack_public_path__ + "static/media/check.643629d0.svg";